<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect x="3" y="2" width="24" height="24" rx="4" fill="#F5F5F5" />
      <path
        d="M9 20.0003L13.3333 15.667"
        stroke="#767676"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6667 12.3333L21.0001 8"
        stroke="#767676"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 8H21V12"
        stroke="#767676"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 16V20H13"
        stroke="#767676"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "ExpandIcon",
};
</script>
